import { Injectable, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ZShareData, ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { ApiService } from '@netfoundry-ui/shared/services';
import { Subject } from 'rxjs';
import { ZitiShareComponent } from './ziti-share.component';

@Injectable({
    providedIn: 'root',
})
export class ZitiShareService {
    dialogRef;
    private data = new Subject<ZShareData>();
    public data$ = this.data.asObservable();
    orgId;
    currentNetwork;

    constructor(public dialogForm: MatDialog, @Inject(ENVIRONMENT) private environment: Environment, private apiService: ApiService) {}

    public show(data: ZShareData) {
        const dialogData = { ...data };
        if(this.environment.orgId) {
            dialogData.brandingOrganizationId = this.environment.orgId;
        }
        this.dialogRef = this.dialogForm.open(ZitiShareComponent, {
            data: dialogData,
            height: '350px',
            width: '640px',
            autoFocus: false,
        });
    }
}
